const getUrlSegments = (url) => {
    if (!url)
        return [];

    return url
        .replace(/^\/+|\/+$/g, '') //remove slashes from start and end
        .split('/');
};

export default getUrlSegments;